import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Autosuggest from 'react-autosuggest'

import './Autocomplete.sass'


const getSuggestionValue = suggestion => suggestion.name;
const renderSuggestion = suggestion => <span>{suggestion.name}</span>

class Autocomplete extends Component {
  constructor() {
    super();

    this.state = {
      value: '',
      suggestions: []
    }
  }

  // Teach Autosuggest how to calculate suggestions for any given input value.
  getSuggestions = value => {
    const inputValue = value.trim().toLowerCase();

    if (inputValue.length === 0) {
      return []
    }

    return this.props.allSuggestions.filter(suggestion => {
      // Remove possible leading/trailing whitespace from search terms and convert to lowercase
      const searchTerms = suggestion.search_terms ? suggestion.search_terms.map(term => term.trim().toLowerCase()) : []

      // Matches beginning of search term/name with the beginning of the input value
      const hasSearchTermMatch = searchTerms.some(term => term.slice(0, inputValue.length) === inputValue)
      const hasNameMatch = suggestion.name.toLowerCase().slice(0, inputValue.length) === inputValue

      return hasSearchTermMatch || hasNameMatch
    })
  }

  onChange = (event, { newValue }) => {
    this.setState({ value: newValue })
  }

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({ suggestions: this.getSuggestions(value) });
  }

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({ suggestions: [] })
  }

  render() {
    const { value, suggestions } = this.state
    const { placeholder, inputComponent, onSelect, allSuggestions } = this.props

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder,
      value,
      onChange: this.onChange
    }

    return (
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        renderInputComponent={inputComponent}
        inputProps={inputProps}
        onSuggestionSelected={onSelect}
      />
    )
  }
}

Autocomplete.propTypes = {
  inputComponent: PropTypes.func,
  placeholder: PropTypes.string,
  onSelect: PropTypes.func,
  allSuggestions: PropTypes.array
}

export default Autocomplete
